import { Factory } from 'rosie';

Factory.define('Role').extend('Id');

Factory.define('RoleWithDefaults')
  .extend('Role')
  .attr('name', 'Default Role')
  .attr('description', 'A default role description.')
  .attr('permissions', [
    'agent', 'liveboards', 'answers:read', 'conversation:general', 'conversation:outbound'
  ])
  .attr('builtin', false)
  .attr('version', 1);
